import { locale } from './locale';

export const environment = {
    production: true,
    locale: locale,
    recaptchaApiKey: '6LfKH_AqAAAAAEn-ww8GepXzeAd2jOEBXpVqm5Ry'
};
